$(document).ready(function () {
  function formatPrice(price) {
    return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  const $flickity = $("product-gallery scroll-carousel").flickity({
    contain: false,
    wrapAround: true,
    prevNextButtons: false,
    pageDots: false,
    groupCells: true,
    cellAlign: "left",
  });
  
if ($(".product").length == 1) {
  
 $(".Product__SlideshowNavArrow--next").on("click", function(){ $flickity.flickity("next"); });
 $(".Product__SlideshowNavArrow--previous").on("click", function(){ $flickity.flickity("previous"); });
 
 function flickitySlider(){
    var value_input = $("input[name='option1']:checked").val();
    var value_input2 = $("input[name='option2']:checked").val();
    var value_input3 = $("input[name='option3']:checked").val();
     
      if(value_input3){
        var createCombo = value_input + " / " + value_input2 + " / " + value_input3;
      }else{
        var createCombo = value_input + " / " + value_input2;
      }
    $("span.custom_product_span").each(function () {
      var getTitle = $(this).text();
      if (getTitle == createCombo) {
        var dataIndex = $(this).attr("data-attr");
        var dataIndex1 = $(
          `.product-gallery__media[data-media-id="${dataIndex}"]`
        ).attr("index");
        $flickity.flickity("select", dataIndex1 - 1);
      } else {
        var value_input3 = $("input[name='option1']:checked").val();
        $("span.custom_product_span").each(function () {
          var getTitle = $(this).text();
          if (getTitle == value_input3) {
            var dataIndex = $(this).attr("data-attr");
            var dataIndex = $(this).attr("data-attr");
            var dataIndex1 = $(`.product-gallery__media[data-media-id="${dataIndex}"]`).attr("index");
            $flickity.flickity("select", dataIndex1 - 1);
          }
        });
      }
    });
  }
  flickitySlider();
  $(document).on("click",".variant-picker__option-values label",function(){
      setTimeout(function () {
          flickitySlider();
      }, 150);
    
    });
  }
  setTimeout(function() {
     $(".variant-picker__option-values-new input:first").attr("checked",true);
  },1000);
function customClass() {
  var variantId = window.location.href.split("variant=")[1];
  $.ajax({
    url: window.location.href,
    method: "GET",
    dataType: "json",
    success: function (response) {
      var variantsData = response.product.variants;
      variantsData.forEach((data) => {
        if (data.id == variantId) {
          var finalPrice = formatPrice(data.price);
          if (data.inventory_quantity <= 0) {
            $(".buy-buttons").addClass("soldOutProduct");
            $("safe-sticky buy-buttons .button.w-full").html(`<span class="sold-out-custom-cls">Sold out</span>`);
          } else {
            var activeCurrency = $("body").attr("store-currency");
            if (activeCurrency == "₹") {
              activeCurrency = "Rs.";
            }
            $(".buy-buttons").removeClass("soldOutProduct");
            $("safe-sticky buy-buttons .button.w-full").html(
              `<span>Add to cart</span><span>${activeCurrency} ${finalPrice}</span>`
            );
          }
        }
      });
    },
  });
}
$(document).on("click",".default-product-template .variant-picker__option-values label",function(){
  setTimeout(function () {
    var getText = $('buy-buttons.buy-buttons button[type="submit"]').text();
    if (getText.includes("Sold out")) {
      $(".default-product-template").addClass("the_product_is_sold_out");
    } else {
      $(".default-product-template").removeClass("the_product_is_sold_out");
    }
   customClass();
  }, 100);
});
  
$(document).on("click",".bundle-product-template-pdp .variant-picker__option-values label",function () {
  setTimeout(function () {
    var getText = $('buy-buttons.buy-buttons button[type="submit"]').text();
    if (getText.includes("Sold out")) {
      $(".bundle-product-template-pdp").addClass("the_product_is_sold_out");
    } else {
      $(".bundle-product-template-pdp").removeClass("the_product_is_sold_out");
    }
    customClass();
  }, 100);
});

$(document).on("click", ".product-gallery__zoom-button", (e) => {
  e.preventDefault();
  $(".product-gallery__media.snap-center.is-selected img").click();
});

$(document).on("click",'.buy-buttons[template="messenger-bag"]',(e) => {
      e.preventDefault();
      var variantId = $('.product .product-info .shopify-product-form input[name="id"]').val();
      var varColor = $(".variant-picker-new-custom .variant-picker__option-values-new input[type=radio]:checked").val();
      var bundleId = $(`.bundle-product[variant-name="${varColor}"]`).attr("variant-id");
      let formData = {items: [{id: variantId,quantity: 1,},{id: bundleId,quantity: 1,}]};

      fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {"Content-Type": "application/json",},
        body: JSON.stringify(formData),
      }).then((response) => {
          document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {bubbles: true,}));
          setTimeout(function () {
            $('.header__secondary-nav a[aria-controls="cart-drawer"]')[0].click();
          }, 100);
        }).catch((error) => {
          console.error("Error:", error);
        });
    });
  
  $(document).on("click",".variant-picker-new-custom .variant-picker__option-values-new .is-disabled",(e)=>{
      e.preventDefault();
      setTimeout(function () {
        $('.buy-buttons[template="messenger-bag"] button').text("sold out");
        $('.buy-buttons[template="messenger-bag"] button').addClass("sold-out-disabled");
      }, 100);
    });

  $(document).on("click",".bundle-product-template-pdp .variant-picker-new-custom .variant-picker__option-values-new  .available",function(){
      setTimeout(function () {
        $('.buy-buttons[template="messenger-bag"] button').removeClass("sold-out-disabled");
        customClass();
      }, 100);
    }
  );

  $("body").on("click",".variant-picker-new-custom .variant-picker__option-values-new label",function () {
    $(this).prev().prop("checked", true);
    var colorName = $(this).prev().val();
    $(".variant-picker-new-custom").find("variant-option-value").text(colorName);
  });

  $(document).on("click",".bundle-product-template-pdp .variant-picker__option-values label",function () {
      setTimeout(function () {
        var checkSelected = $('.variant-picker-new-custom .variant-picker__option-values-new input[type="radio"]:checked').next().hasClass("is-disabled");
        if (checkSelected == false) {
          $('.buy-buttons[template="messenger-bag"] button').removeClass("sold-out-disabled");
          customClass();
        } else {
          $(".buy-buttons").removeClass("soldOutProduct");
          $("safe-sticky buy-buttons .button.w-full").html(`<span class="sold-out-custom-cls">Sold out</span>`);
        }
      }, 100);
    }
  );
  function flickity_sliders($product) {
    var value_input = $product.find("input[name='option1']:checked").val();
    var value_input2 = $product.find("input[name='option2']:checked").val();
    var createCombo = value_input + " / " + value_input2;
    $product.find(".csmt-product-data span.custom_product_span").each(function () {
        var getTitle = $(this).text();
        if (getTitle == createCombo) {
          var dataIndex = $(this).attr("data-attr");
          var dataIndex1 = $(`.product-gallery__media[data-media-id="${dataIndex}"]`).attr("index");
          $flickity.each(function (n) {
            if (n == i) {
              $(this).flickity("select", dataIndex1 - 1);
            }
          });
        } else {
          var value_input = $product.find("input[name='option1']:checked").val();
          $product.find(".csmt-product-data span.custom_product_span").each(function () {
              var getTitle = $(this).text();
              if (getTitle == value_input) {
                var dataIndex = $(this).attr("data-attr");
                var dataIndex = $(this).attr("data-attr");
                var dataIndex1 = $( `.product-gallery__media[data-media-id="${dataIndex}"]`).attr("index");
                $flickity.each(function (n) {
                  if (n == i) {
                    $(this).flickity("select", dataIndex1 - 1);
                  }
                });
              }
            });
        }
      });
   }
  if ($(".product").length > 1) {
   
    $(".product").each(function (i) {
      var $product = $(this);
      setTimeout(function () {
       flickity_sliders($product);
      }, 100);
    });
    
    $(".product").each(function (i) {
      var $product = $(this);
      $product.on("click", ".variant-picker__option-values label", function () {
        setTimeout(function () {
          flickity_sliders($product);
        }, 100);
      });
    });

    $(".product").each(function(){
      var $flickityInstance = $(this).find(".product-gallery scroll-carousel").flickity();
      $(this).find(".Product__SlideshowNavArrow--next").on("click", function () { $flickityInstance.flickity("next"); });
      $(this).find(".Product__SlideshowNavArrow--previous").on("click", function () { $flickityInstance.flickity("previous"); });
    });
  }
});
